var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "divBox",
    },
    [
      _c("search-page", {
        directives: [
          {
            name: "hasPermi",
            rawName: "v-hasPermi",
            value: ["platform:task:taskDefinition:list"],
            expression: "['platform:task:taskDefinition:list']",
          },
        ],
        ref: "searchPage",
        attrs: {
          "form-data": _vm.formData,
          columns: _vm.columns,
          request: _vm.getList,
        },
        scopedSlots: _vm._u([
          {
            key: "page-operation",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "mb8" },
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "hasPermi",
                            rawName: "v-hasPermi",
                            value: ["platform:task:taskDefinition:create"],
                            expression:
                              "['platform:task:taskDefinition:create']",
                          },
                        ],
                        attrs: { size: "small", type: "primary" },
                        on: { click: _vm.handleAdd },
                      },
                      [_vm._v("新增任务")]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "table-append",
            fn: function () {
              return [
                _c("el-table-column", {
                  attrs: {
                    fixed: "right",
                    label: "操作",
                    align: "center",
                    "min-width": "220",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "header",
                      fn: function () {
                        return [
                          _c(
                            "p",
                            [
                              _c(
                                "span",
                                { staticStyle: { "padding-right": "5px" } },
                                [_vm._v("操作")]
                              ),
                              _c("right-toolbar", {
                                attrs: { columns: _vm.columns },
                                on: { refresh: _vm.refreshList },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "hasPermi",
                                  rawName: "v-hasPermi",
                                  value: [
                                    "platform:task:taskDefinition:create",
                                  ],
                                  expression:
                                    "['platform:task:taskDefinition:create']",
                                },
                              ],
                              on: {
                                click: function ($event) {
                                  return _vm.handleCopy(row)
                                },
                              },
                            },
                            [_vm._v("复制")]
                          ),
                          _c("el-divider", {
                            attrs: { direction: "vertical" },
                          }),
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "hasPermi",
                                  rawName: "v-hasPermi",
                                  value: [
                                    "platform:task:taskDefinition:update",
                                  ],
                                  expression:
                                    "['platform:task:taskDefinition:update']",
                                },
                              ],
                              on: {
                                click: function ($event) {
                                  return _vm.handleUpdate(row)
                                },
                              },
                            },
                            [_vm._v("编辑")]
                          ),
                          _c("el-divider", {
                            attrs: { direction: "vertical" },
                          }),
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "hasPermi",
                                  rawName: "v-hasPermi",
                                  value: [
                                    "platform:task:taskDefinition:delete",
                                  ],
                                  expression:
                                    "['platform:task:taskDefinition:delete']",
                                },
                              ],
                              on: {
                                click: function ($event) {
                                  return _vm.handleDelete(row)
                                },
                              },
                            },
                            [_vm._v("删除")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            title: _vm.title,
            visible: _vm.open,
            width: "700px",
            top: "3vh",
            "append-to-body": "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.open = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "所属应用", prop: "applicationId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "from-ipt-width",
                      on: { change: _vm.changeApp },
                      model: {
                        value: _vm.form.applicationId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "applicationId", $$v)
                        },
                        expression: "form.applicationId",
                      },
                    },
                    [
                      _vm._l(_vm.appList, function (item, index) {
                        return [
                          _c("el-option", {
                            key: index,
                            attrs: {
                              label: item.label,
                              value: item.value,
                              disabled: item.disabled,
                            },
                          }),
                        ]
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "任务名称", prop: "taskName" } },
                [
                  _c("el-input", {
                    staticClass: "from-ipt-width",
                    attrs: { placeholder: "请输入任务名称", maxlength: 30 },
                    model: {
                      value: _vm.form.taskName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "taskName", $$v)
                      },
                      expression: "form.taskName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "副标题", prop: "taskSubtitle" } },
                [
                  _c("el-input", {
                    staticClass: "from-ipt-width",
                    attrs: { placeholder: "请输入任务名称", maxlength: 30 },
                    model: {
                      value: _vm.form.taskSubtitle,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "taskSubtitle", $$v)
                      },
                      expression: "form.taskSubtitle",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "任务编码", prop: "taskCode" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "from-ipt-width",
                      on: { change: _vm.changeTaskCode },
                      model: {
                        value: _vm.form.taskCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "taskCode", $$v)
                        },
                        expression: "form.taskCode",
                      },
                    },
                    _vm._l(_vm.taskCodeOptions, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "任务类型", prop: "taskType" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "from-ipt-width",
                      on: { change: _vm.changeTaskType },
                      model: {
                        value: _vm.form.taskType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "taskType", $$v)
                        },
                        expression: "form.taskType",
                      },
                    },
                    [
                      _vm._l(_vm.taskTypeOptions, function (item, index) {
                        return [
                          _c("el-option", {
                            key: index,
                            attrs: {
                              label: item.label,
                              value: item.value,
                              disabled: item.disabled,
                            },
                          }),
                        ]
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm.form.taskType === "4"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "客服：", prop: "popupId" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "from-ipt-width",
                          attrs: {
                            placeholder: "请选择客服",
                            filterable: "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.popupId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "popupId", $$v)
                            },
                            expression: "form.popupId",
                          },
                        },
                        _vm._l(_vm.qrcodeList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.pageName, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.form.taskCode !== "commission_task"
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: "奖励类型", prop: "rewardType" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "from-ipt-width",
                            model: {
                              value: _vm.form.rewardType,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "rewardType", $$v)
                              },
                              expression: "form.rewardType",
                            },
                          },
                          _vm._l(_vm.rewardTypeOptions, function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: item.label,
                                value: item.value,
                                disabled: item.disabled,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "单次奖励数值", prop: "rewardValue" } },
                      [
                        _c("el-input-number", {
                          attrs: {
                            min: 0,
                            step: _vm.form.rewardType === 1 ? 1 : 0.0001,
                            "controls-position": "right",
                            "step-strictly": "",
                            placeholder: "请输入奖励数值",
                          },
                          model: {
                            value: _vm.form.rewardValue,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "rewardValue", $$v)
                            },
                            expression: "form.rewardValue",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm.form.taskType === "5" ? void 0 : _vm._e(),
              _vm.form.taskType === "6"
                ? [
                    _c("el-form-item", { attrs: { label: "选择商品" } }, [
                      _c(
                        "div",
                        { staticClass: "acea-row" },
                        [
                          _vm._l(_vm.form.productList, function (item, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "pictrue" },
                              [
                                _c("img", {
                                  attrs: { src: item.productImage },
                                }),
                                _c("i", {
                                  staticClass: "el-icon-error btndel",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleRemove(index)
                                    },
                                  },
                                }),
                              ]
                            )
                          }),
                          _vm.form.productList.length < 8
                            ? _c(
                                "div",
                                {
                                  staticClass: "upLoadPicBox",
                                  on: { click: _vm.handleSelectProduct },
                                },
                                [
                                  _c("div", { staticClass: "upLoad" }, [
                                    _c("i", {
                                      staticClass:
                                        "el-icon-plus cameraIconfont",
                                    }),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]),
                    _c(
                      "el-form-item",
                      { attrs: { label: "浏览时长", prop: "browseDuration" } },
                      [
                        _c("el-input-number", {
                          attrs: {
                            min: 1,
                            step: 1,
                            "controls-position": "right",
                            "step-strictly": "",
                          },
                          model: {
                            value: _vm.form.browseDuration,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "browseDuration", $$v)
                            },
                            expression: "form.browseDuration",
                          },
                        }),
                        _vm._v("秒 "),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              !["5", "6"].includes(_vm.form.taskType)
                ? [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label:
                            _vm.form.taskCode === "commission_task"
                              ? "所需次数"
                              : "每日上限",
                          prop: "dailyLimit",
                        },
                      },
                      [
                        _c("el-input-number", {
                          attrs: {
                            min: 1,
                            step: 1,
                            "controls-position": "right",
                            "step-strictly": "",
                            placeholder: "请输入每日限制次数",
                          },
                          model: {
                            value: _vm.form.dailyLimit,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "dailyLimit", $$v)
                            },
                            expression: "form.dailyLimit",
                          },
                        }),
                        _vm.form.taskCode === "commission_task"
                          ? _c("div", { staticClass: "from-tips" }, [
                              _vm._v(
                                "得到单次佣金任务奖励所需完成任务内容的次数"
                              ),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm.form.taskType === "7"
                ? [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "小程序appid",
                          prop: "miniProgramAppId",
                        },
                      },
                      [
                        _c("el-input", {
                          staticClass: "from-ipt-width",
                          attrs: { placeholder: "请输入小程序appid" },
                          model: {
                            value: _vm.form.miniProgramAppId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "miniProgramAppId", $$v)
                            },
                            expression: "form.miniProgramAppId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: "小程序路径", prop: "miniProgramUrl" },
                      },
                      [
                        _c("el-input", {
                          staticClass: "from-ipt-width",
                          attrs: { placeholder: "请输入小程序路径" },
                          model: {
                            value: _vm.form.miniProgramUrl,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "miniProgramUrl", $$v)
                            },
                            expression: "form.miniProgramUrl",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : _c(
                    "el-form-item",
                    { attrs: { label: "任务链接", prop: "taskUrl" } },
                    [
                      _c("el-input", {
                        staticClass: "from-ipt-width",
                        attrs: { placeholder: "请输入任务链接" },
                        model: {
                          value: _vm.form.taskUrl,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "taskUrl", $$v)
                          },
                          expression: "form.taskUrl",
                        },
                      }),
                    ],
                    1
                  ),
              _c(
                "el-form-item",
                { attrs: { label: "倍数领取", prop: "doubleRewardSwitch" } },
                [
                  _c("el-switch", {
                    attrs: {
                      "active-value": 1,
                      "inactive-value": 0,
                      "active-text": "开启",
                      "inactive-text": "关闭",
                    },
                    model: {
                      value: _vm.form.doubleRewardSwitch,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "doubleRewardSwitch", $$v)
                      },
                      expression: "form.doubleRewardSwitch",
                    },
                  }),
                ],
                1
              ),
              _vm.form.doubleRewardSwitch
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "领取倍数",
                        prop: "doubleRewardMultiple",
                      },
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          min: 0,
                          step: 0.01,
                          "controls-position": "right",
                          "step-strictly": "",
                          placeholder: "请输入倍数",
                        },
                        model: {
                          value: _vm.form.doubleRewardMultiple,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "doubleRewardMultiple", $$v)
                          },
                          expression: "form.doubleRewardMultiple",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "排序", prop: "sort" } },
                [
                  _c("el-input-number", {
                    attrs: {
                      min: 0,
                      step: 1,
                      "controls-position": "right",
                      "step-strictly": "",
                      placeholder: "请输入排序",
                    },
                    model: {
                      value: _vm.form.sort,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "sort", $$v)
                      },
                      expression: "form.sort",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "任务状态", prop: "taskStatus" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.taskStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "taskStatus", $$v)
                        },
                        expression: "form.taskStatus",
                      },
                    },
                    _vm._l(_vm.statusOptions, function (item, index) {
                      return _c(
                        "el-radio",
                        { key: index, attrs: { label: item.value } },
                        [_vm._v(_vm._s(item.label))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitForm } },
                [_vm._v("确 定")]
              ),
              _c("el-button", { on: { click: _vm.cancel } }, [_vm._v("取 消")]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }